import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheck, FiX, FiLoader, FiRefreshCw } from 'react-icons/fi';
import { transactionQueue, TransactionStatus } from '../utils/transactionUtils';
import '../styles/TransactionQueue.css';

const TransactionQueue = () => {
  const [transactions, setTransactions] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateQueue = () => {
      setTransactions([...transactionQueue.queue]);
      setIsVisible(transactionQueue.queue.length > 0);
    };

    // Update initially
    updateQueue();

    // Subscribe to queue changes
    const interval = setInterval(updateQueue, 1000);
    return () => clearInterval(interval);
  }, []);

  const getStatusIcon = (status) => {
    switch (status) {
      case TransactionStatus.SUCCESS:
        return <FiCheck className="status-icon success" />;
      case TransactionStatus.FAILED:
        return <FiX className="status-icon failed" />;
      case TransactionStatus.RETRY:
        return <FiRefreshCw className="status-icon retry" />;
      case TransactionStatus.PROCESSING:
        return <FiLoader className="status-icon processing" />;
      default:
        return <FiLoader className="status-icon queued" />;
    }
  };

  const formatAmount = (amount, decimals = 18) => {
    try {
      return parseFloat(amount).toFixed(decimals);
    } catch {
      return amount;
    }
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div 
        className="transaction-queue"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
      >
        <div className="queue-header">
          <h3>Transaction Queue</h3>
          <span className="queue-count">{transactions.length} pending</span>
        </div>

        <div className="queue-items">
          {transactions.map((tx, index) => (
            <motion.div 
              key={index}
              className="queue-item"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
            >
              <div className="transaction-info">
                <div className="transaction-type">
                  {tx.type === 'BNB_TRANSFER' ? 'Send BNB' : 'Token Transfer'}
                </div>
                <div className="transaction-amount">
                  {formatAmount(tx.params.amount)} {tx.type === 'BNB_TRANSFER' ? 'BNB' : tx.params.symbol}
                </div>
                <div className="transaction-address">
                  To: {tx.params.to.slice(0, 6)}...{tx.params.to.slice(-4)}
                </div>
              </div>

              <div className="transaction-status">
                {getStatusIcon(tx.status)}
                {tx.retryCount > 0 && (
                  <span className="retry-count">
                    Retry {tx.retryCount}/3
                  </span>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TransactionQueue; 